/**
 * Tabs placement of TabContainer.
 * @private
 */
enum TabContainerTabsPlacement {
	/**
	 * The tab strip is displayed above the tab content (Default)
	 * @private
	 */
	Top = "Top",

	/**
	 * The tab strip is displayed below the tab content
	 * @private
	 */
	Bottom = "Bottom",
}

export default TabContainerTabsPlacement;
